import ScheduleWorkout from './ScheduleWorkout';

export default ScheduleWorkout;
